import React, { useState, useEffect } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
import DatePicker from "rsuite/DatePicker";
import { toast, Bounce } from "react-toastify";

const ExtendFreeTrial = ({ data, setApiRun }) => {
	const [newFreeTrialDate, setNewFreeTrialDate] = useState(null);
	const [newFreeTrialDateTemp, setNewFreeTrialDateTemp] = useState(new Date());

	const { fetchPostData, error } = useFetchPost();
	useEffect(() => {
		if (data && data.free_trial_expiry_date) {
			setNewFreeTrialDate(new Date(data.free_trial_expiry_date * 1000));
		}
	}, [data]);

	const handleClose = () => {
		const extendFreeTrialModal = document.getElementById("extendFreeTrial");
		extendFreeTrialModal.classList.remove("show");
		extendFreeTrialModal.style.display = "none";
	};
	//form validation with data set
	const handleNewFreeTrailDateChange = (date) => {
		const newdate = new Date(date);
		const day = String(newdate.getDate()).padStart(2, "0");
		const month = String(newdate.getMonth() + 1).padStart(2, "0");
		const year = newdate.getFullYear();

		const formattedDate = `${month}-${day}-${year}`;

		setNewFreeTrialDate(new Date(newdate));
		//new Date("2024-04-25").getTime()
		setNewFreeTrialDateTemp(formattedDate);
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		// Submit form data

		const postData = {
			product_key: data && data.product_key,
			user_uuid: data && data.customer_user_uuid,
			app_token: data && data.customer_id,
			store_key: data && data.store_key,
			new_free_trial_date: newFreeTrialDate,
			is_live: data && data.isLive,
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi6/extend-free-trial";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}
		if (responseData && responseData.status == "SUCCESS") {
			setApiRun(true);
			// Reset form
			setNewFreeTrialDate(new Date());
			setNewFreeTrialDateTemp(new Date());
			toast.success(responseData.message, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";

			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			console.warn("Something went wrong .in change to muvi ownership");
		}

		// Close the modal
		const extendFreeTrialModal = document.getElementById("extendFreeTrial");
		extendFreeTrialModal.classList.remove("show");
		extendFreeTrialModal.style.display = "none";
	};

	return (
		<div
			className="modal fade"
			id="extendFreeTrial"
			tabindex="-1"
			role="dialog"
			aria-labelledby="extendFreeTrialLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="extendFreeTrialLabel">
							Extend Free Trial
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Company
								</label>
								<input
									type="text"
									className="form-control"
									disabled
									value={data && data.company_name}
								/>
							</div>
							<div class="form-group">
								<label for="recipient-name" className="control-label">
									Extend Till Date
								</label>
								<DatePicker
									oneTap
									block={true}
									value={newFreeTrialDate}
									onChange={handleNewFreeTrailDateChange}
								/>
								{/* <DatePicker
									selected={newFreeTrialDate}
									dateFormat="dd-MM-yyyy" // You can set the date format here
									placeholderText="Select date"
									onChange={handleNewFreeTrailDateChange}
									minDate={new Date()}
									yearDropdownItemNumber={15}
									block={true}
								/> */}
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<span type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</span>
						<span type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExtendFreeTrial;



// WEBPACK FOOTER //
// ./src/components/crm/modals/ExtendFreeTrial.jsx